import {
  queryBetplanLotterys,
  queryBetplans,
  queryBetplanBodys
} from "@/api/plan";

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async queryPlanBetplanLotterys({ commit }, playload) {
      return await queryBetplanLotterys(playload);
    },
    async queryPlanBetplans({ commit }, playload) {
      return await queryBetplans(playload);
    },
    async queryPlanBetplanBodys({ commit }, playload) {
      return await queryBetplanBodys(playload);
    }
  }
};
